<script>
  import { Spinner } from 'element-ui'
  export default {
    name:'Spinner',
    extends:Spinner
  }
</script>
